module.exports = __webpack_public_path__ + "static/media/431496681_786946836350960_5572262494726017977_n (1).af6e0b5f.jpg";